var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from 'react';
import { endpoints } from '../network/endpoints';
import { useApiMutation } from '../../../infra/api';
import { getSessionBrand } from '../../../infra/session';
import { getUrlPrefixFromView, useNavigate } from '../../../infra/routing';
import { getConciergeManager } from '../../concierge';
import { markAsDismissed, markAsDismissedByAdmin } from './utils';
export var useActionHandlers = function (session, subscription, close) {
    var _a = useState(null), pendingAction = _a[0], setPendingAction = _a[1];
    var navigate = useNavigate();
    var brand = session ? getSessionBrand(session) : null;
    var payInvoiceMutation = useApiMutation({
        endpoint: endpoints.payInvoiceMutation,
    });
    var tryPaymentAgain = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setPendingAction('try-payment-again');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, payInvoiceMutation.mutateAsync({
                            brandId: brand.id,
                            invoiceId: subscription.invoiceId,
                            subscriptionId: subscription.subscriptionId,
                        })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    console.log('Failed to retry invoice', error_1);
                    return [3 /*break*/, 5];
                case 4:
                    setPendingAction(null);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var changePaymentCard = function () {
        close();
        var urlPrefix = getUrlPrefixFromView(session.view);
        var pathname = "".concat(urlPrefix, "/settings/payment-card");
        navigate(pathname);
    };
    var contactSupport = function () { return __awaiter(void 0, void 0, void 0, function () {
        var chatManager;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setPendingAction('contact-support');
                    return [4 /*yield*/, getConciergeManager()];
                case 1:
                    chatManager = _a.sent();
                    if (!(chatManager && !chatManager.isMounted())) return [3 /*break*/, 3];
                    return [4 /*yield*/, chatManager.mount()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    chatManager.open();
                    setPendingAction(null);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSignOut = function () {
        navigate('/sign-out');
    };
    var handleClose = function () {
        markAsDismissed();
        close();
    };
    var handleCloseByAdmin = function () {
        markAsDismissedByAdmin();
        close();
    };
    return {
        pendingAction: pendingAction,
        handlers: {
            'contact-support': contactSupport,
            'try-payment-again': tryPaymentAgain,
            'change-payment-card': changePaymentCard,
            'admin-dismissal': handleCloseByAdmin,
        },
        dismissHandlers: {
            signOut: handleSignOut,
            close: handleClose,
        },
    };
};
export var actionNames = {
    'contact-support': 'Chat with Support',
    'try-payment-again': 'Try payment again',
    'change-payment-card': 'Update payment card',
    'admin-dismissal': 'Sys Admin Override',
};
